import { Component, OnInit, Input } from '@angular/core';
import { MapService } from '@core/services/map.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'avuxi',
    templateUrl: './avuxi.component.html',
    standalone: true,
    imports: [NgIf],
})
export class AvuxiComponent implements OnInit {
  public readonly TOP_LOCATIONS = 'top_locations';

  @Input()
  position: any;
  @Input()
  type: string;
  @Input()
  brand: any;
  @Input()
  action: 'click' | 'show';

  LSE_TYPES: { [key: string]: string };

  constructor(private mapService: MapService) {
    this.LSE_TYPES = {
      map: '4e865593-fb30-4ba4-a14b-d9af1e0a7cf0',
      top_locations: '9c386047-a717-4e8a-819a-784bfba5c7f0',
      near_by: '',
    };
  }

  ngOnInit() {
    this.mapService.initAvuxi(this.action, this.type);
  }
}
